import { useEffect } from 'react';
import { useProduct } from '@thd-nucleus/data-sources';
import {
  ITEM_DOMAINS, heightRE, lengthRE, widthRE
} from '../constants';

export const useOrderSample = ({ itemId, storeId, zipCode }) => {

  const domains = ['specificationGroup', 'pricing', 'fulfillment', 'availabilityType', 'identifiers'];

  let [makeItemRequest, { loading, data: productData, error }] = useProduct({
    itemId,
    storeId,
    domains: ITEM_DOMAINS,
    ssr: false,
    lazy: true
  });

  useEffect(() => {
    if (storeId && storeId !== '8119') {
      makeItemRequest();
    }
  }, [storeId]);

  const sampleId = productData?.product?.identifiers?.sampleId;
  const isSuperSku = productData?.product?.identifiers?.isSuperSku;
  const parentId = productData?.product?.identifiers?.parentId;

  const [makeSampleReq, sample] = useProduct({
    ssr: false,
    lazy: true,
    domains,
    itemId: sampleId,
    storeId,
    zipCode,
  });

  useEffect(() => {
    if (sampleId && zipCode && storeId !== '8119') {
      makeSampleReq({ variables: { storeId, zipCode } });
    }
  }, [sampleId, zipCode, storeId]);

  let dimensionText = '';
  let price;

  const product = sample?.data?.product || {};

  if (product.specificationGroup) {
    const getDimensionText = (dimension) => {
      return `${(dimension.specValue.match(/\d+/g) || [])[0]} ${dimension.specName.split('(')[1].split(')')[0]}`;
    };

    const { specifications: dimensions } = product.specificationGroup.find((spec) => spec.specTitle === 'Dimensions');

    const length = dimensions.find(({ specName }) => lengthRE.test(specName) || heightRE.test(specName));
    const lengthText = length ? getDimensionText(length) : '';
    const width = dimensions.find(({ specName }) => widthRE.test(specName));
    const widthText = width ? getDimensionText(width) : '';

    if (length && width) {
      dimensionText = `${lengthText} x ${widthText}`;
    }

    if (product?.pricing) {
      price = product.pricing.value;
    }
  }
  const hasSample = !!sampleId;

  return { data: {
    price, dimensionText, hasSample, isSuperSku, parentId, sampleId
  },
  loading: loading || sample?.loading };
};
